/* eslint-disable jsx-a11y/no-autofocus */
import { makeStyles } from '@mui/styles';
import Loader from 'apollo-react/components/Loader';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useRef } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import { getCreatePat, getRevokePat } from './PatDialogSelectors';
import { clearTopMenuModal, closeTopMenuModal } from '../../actions/TopMenuActions';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';

const useStyles = makeStyles({
  patInput: {
    minWidth: '100%',
  },
  createContent: {
    minWidth: 300,
    minHeight: 150,
  },
  revokeContent: {
    minWidth: 300,
    minHeight: 50,
  },
  modal: {
    maxWidth: 'unset',
    minWidth: '300px',
  },
});

const PatDialogComponent = () => {
  const dispatch = useDispatch();
  const patInputRef = useRef(null);
  const classes = useStyles();
  const translateString = useTranslation();
  const { isMobileDevice } = useWindowDimensions();

  const selectInput = () => {
    patInputRef.current && patInputRef.current.select();
  };

  // Starts fading out the modal
  const handleModalClose = () => {
    batch(() => {
      dispatch(clearTopMenuModal());
      dispatch(closeTopMenuModal());
    });
  };

  const create = useSelector(getCreatePat);
  const revoke = useSelector(getRevokePat);

  const open = create.isOpen || revoke.isOpen;
  const isLoading = (create.isOpen && !create.message) || (revoke.isOpen && !revoke.message);
  const isCreate = !!create.message;

  const Content = isCreate ? (
    <>
      <span>{create.message}</span>
      <TextField
        readOnly
        autoFocus
        inputRef={patInputRef}
        onClick={selectInput}
        className={classes.patInput}
        value={create.pat}
      />
    </>
  ) : (
    <span>{revoke.message}</span>
  );

  const buttonProps = isCreate
    ? [
        {
          color: 'primary',
          label: translateString('Copy and Close'),
          onClick: () => {
            navigator.clipboard.writeText(create.pat);
            handleModalClose();
          },
        },
      ]
    : [
        {
          label: translateString('Close'),
          onClick: () => {
            handleModalClose();
          },
        },
      ];

  const title = isLoading ? '' : translateString(isCreate ? 'Create PAT' : 'Revoke PAT');

  return (
    <Modal
      className={classes.modal}
      buttonProps={buttonProps}
      disableBackdropClick
      disableEscapeKeyDown
      disablePortal
      onClose={() => handleModalClose()}
      open={open}
      title={title}
      PaperProps={{ style: { margin: isMobileDevice ? 16 : 32 } }}
    >
      <div className={isCreate ? classes.createContent : classes.revokeContent}>
        {isLoading ? <Loader isInner /> : Content}
      </div>
    </Modal>
  );
};

export default PatDialogComponent;
